export const API_BASE_URL =
  (import.meta.env.VITE_API_URL ?? import.meta.env.VITE_API_BASE_URL ?? '').trim() || ''

export const DEV_AUTH_ENABLED =
  import.meta.env.DEV && import.meta.env.VITE_DISABLE_AUTH === 'true'

export const PUBLIC_SIGNUP_ENABLED =
  import.meta.env.DEV || import.meta.env.VITE_PUBLIC_SIGNUP === 'true'
